'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForgotPasswordConfirmPage = function ForgotPasswordConfirmPage() {
  return _react2.default.createElement(
    'div',
    { className: 'grey-section-full' },
    _react2.default.createElement(
      'div',
      { className: 'max-width-div-center' },
      _react2.default.createElement(
        'h1',
        { className: '_2nd-header-copy' },
        'Reset your password'
      ),
      _react2.default.createElement(
        'div',
        { className: 'log-in-form-block w-form' },
        _react2.default.createElement(
          'div',
          { className: 'text-form' },
          'Check your email for a link to reset your password. If it doesn\'t appear within a few minutes, check your spam folder.'
        ),
        _react2.default.createElement(
          _reactRouterDom.Link,
          { className: 'button w-button', to: '/login' },
          _react2.default.createElement(
            'div',
            null,
            'Return to sign in'
          )
        )
      )
    )
  );
};

exports.default = ForgotPasswordConfirmPage;